export { AlertsComponent } from './alerts.component';
